import React from 'react';
import { FaTimesCircle } from 'react-icons/fa';
import * as S from '../GraciasPage.styles';
import WhatsAppButton from './WhatsAppButton';
import { generateSupportMessage } from '../utils';
import { PAYMENT_LINK } from '../constants';

/**
 * Estado de pago fallido
 */
const FailureState = ({ t }) => {
  return (
    <>
      <S.StatusIcon $status="failure">
        <FaTimesCircle />
      </S.StatusIcon>
      <S.Title>{t('gracias.failure.title')}</S.Title>
      <S.Message>{t('gracias.failure.message')}</S.Message>
      <S.SubMessage>{t('gracias.failure.submessage')}</S.SubMessage>
      
      <S.ButtonGroup>
        <S.RetryButton 
          href={PAYMENT_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('gracias.failure.retryButton')}
        </S.RetryButton>
        
        <WhatsAppButton href={generateSupportMessage()} />
      </S.ButtonGroup>
    </>
  );
};

export default FailureState;

